import styled from "styled-components/macro";

import { ReactComponent as IconCheck } from "../../assets/icons/icon_checkmark.svg";
import { ReactComponent as IconClose } from "../../assets/icons/icon_close.svg";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 24px 12px;
  z-index: 1000;
  overflow: auto;
    
  @media (max-width: 979px) {
    padding: 0;
  }
`;

export const PopupCard = styled.div`
  position: relative;
  background-color: #F8F8F8;
  border-radius: 24px;
  width: 100%;
  max-width: 1400px;
  margin-top: 24px;
  padding: 100px 116px;

  @media (max-width: 1439px) {
    margin-top: 0;
  }

  @media (max-width: 979px) {
    padding: 60px 12px 0;
    border-radius: 0;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 67px;
  margin-bottom: 40px;

  h2 {
    font-family: "Cormorant Infant", sans-serif;
    font-weight: 600;
    font-size: 57px;
      
    @media (max-width: 1439px) {
      font-size: 45px;
    }
      
    @media (max-width: 979px) {
      font-size: 50px;
      width: 100%;
      text-align: center;
    }
  }
`;

export const CLoseContainer = styled.div`
  padding: 15px;
  position: absolute;
  right: 12px;
  top: 12px;
  display: flex;
  align-items: center;
`

export const Close = styled(IconClose)`
  width: 18px;
  height: 18px;
  cursor: pointer;
  transition: 0.2s;
  
  path {
    stroke: #141414;
  }
  
  &:hover {
    transition: 0.2s;
    transform: scale(1.2);
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 40px;

  .left {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 14px;
      
      @media (max-width: 979px) {
        align-items: center;
      }
  }

  h3 {
    font-family: "Cormorant Infant", sans-serif;
    line-height: 86%;
    margin: 0;
    font-size: 35px;
    font-weight: 600;

      @media (max-width: 979px) {
        text-align: center;
        font-size: 30px;
      }
  }
    
    @media (max-width: 979px) {
      flex-direction: column;
      align-items: center;
    }
`;

export const Label = styled.span`
  display: inline-block;
  padding: 8px 16px;
  font-size: 16px;
  line-height: 1;
  font-weight: 500;
  background-color: #BFDCF5;
  border-radius: 22px;
`;

export const SectionTitle = styled.button<{ $open?: boolean }>`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: transparent;
  border: 1px solid ${props => (props.$open ? "#1983FF" : "#B4B4B4")};
  color: inherit;
  border-radius: 70px;
  padding: 26px 40px;
  cursor: pointer;
  text-align: left;
  margin-bottom: 14px;


  @media (max-width: 979px) {
    padding: 16px 30px;
    margin-bottom: 12px;
  }

  .title {
    font-size: 22px;
    line-height: 31px;
    font-weight: 400;

    @media (max-width: 1439px) {
      font-size: 20px;
    }
      
    @media (max-width: 979px) {
      font-size: 16px;
      line-height: 18px;
    }
  }
`;

export const SectionMeta = styled.div`
  font-size: 18px;
  line-height: 25px;
  color: #A7A7A7;

  @media (max-width: 979px) {
    font-size: 16px;
    line-height: 18px;
  }
`;

export const ToggleIcon = styled.div<{ $open?: boolean }>`
  min-width: 14px;
  min-height: 14px;
  transform: ${({ $open }) => ($open ? "rotate(45deg)" : "rotate(0deg)")};
  transition: transform 0.2s ease;
  margin-left: auto;

  svg {
    display: block;
  }

  svg path {
    stroke: #A7A7A7;
  }
`;

export const SectionAction = styled.button`
  background: none;
  border: none;
  color: #55749F;
  cursor: pointer;
  font-size: 16px;
  white-space: nowrap;
  
    &:hover {
      text-decoration: underline;
    }
`;

export const ItemContainer = styled.div`
  overflow: hidden;
  background-color: #fff;
  border-radius: 24px;
  margin-bottom: 14px;
`;

export const ItemInner = styled.div`
  padding: 26px 40px;
  font-size: 18px;
  line-height: 140%;

  @media (max-width: 979px) {
    padding: 32px;
    font-size: 16px;
  }
`;

export const WeekLabel = styled.div`
  font-size: 18px;
  line-height: 25px;
  color: #A7A7A7;
  margin-bottom: 24px;
    
  @media (max-width: 979px) {
    font-size: 16px;
    margin-bottom: 14px;
  }
`;

export const LeadText = styled.p`
  margin: 0 0 16px;
  font-weight: 700;
    
  @media (max-width: 979px) {
    letter-spacing: -0.02em;
  }
`;

export const PointsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
    
  @media (max-width: 979px) {
    gap: 8px;
  }
`;

export const PointRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
    
    span {
      font-size: 18px;
        
      @media (max-width: 979px) {
        font-size: 16px;
        letter-spacing: -0.02em;
      }
`;

export const CheckIcon = styled(IconCheck)`
  width: 16px;
  height: 11px;

  path {
    stroke: #679D00;
  }
`;
